var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66198 0.859375H4.16932C2.11932 0.859375 0.833984 2.31071 0.833984 4.36537V9.90804C0.833984 11.9627 2.11332 13.414 4.16932 13.414H10.052C12.1087 13.414 13.388 11.9627 13.388 9.90804V7.22271",
    stroke: "#5C5F62",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88541 6.28062L9.86741 1.29862C10.4881 0.678618 11.4941 0.678618 12.1147 1.29862L12.9261 2.10995C13.5467 2.73062 13.5467 3.73728 12.9261 4.35728L7.92008 9.36329C7.64875 9.63462 7.28075 9.78729 6.89675 9.78729H4.39941L4.46208 7.26729C4.47141 6.89662 4.62275 6.54328 4.88541 6.28062Z",
    stroke: "#5C5F62",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11035 2.06836L12.1544 5.11236",
    stroke: "#5C5F62",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.627d9ce6bacba24f936bb09c0a89c836.svg";
export { ForwardRef as ReactComponent };